import React from 'react';
import { Container } from '@mui/material';
import SaidaUnificar from '../components/saida/SaidaUnificar';

const SaidaUnificarPage: React.FC = () => {
  return (
    <Container maxWidth="xl" sx={{ mt: 4, mb: 4 }}>
      <SaidaUnificar />
    </Container>
  );
};

export default SaidaUnificarPage;
